<template>
  <div>
    <request-quotation
      :view_RequestQuotation="request_quotation"
      @sendRequestQuotationEvent="$emit('sendRequestQuotationEvent')"
      className="mybooking-online"
      :readonlyService="readonlyService"
      :step="step"
      :readonly="false"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

import vSelect from "vue-select";
import Select2 from "v-select2-component";
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
  BFormSelect,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import RequestQuotation from "@/views/wr1/quotation/RequestQuotation.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    Select2,
    VueGoodTable,
    BFormSelect,
    RequestQuotation,
  },
  props: {
    step: { default: null },
    view_RequestQuotation: { default: null },
    readonlyService: { default: null },
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  mounted() {},
  watch: {},
  methods: {},
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-primary",
        2: "light-warning",
        3: "light-danger",
        6: "light-warning",
        7: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      request_quotation: this.view_RequestQuotation,
    };
  },
};
</script>
<style>
.select2-container--default .select2-selection--single {
  border: 1px solid #d8d6de;
}
.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}
.is-invalid .select2-selection--single {
  border: 1px solid #ea5455;
}
.is-invalid .select2-selection--single::before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ea5455' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ea5455' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
}
.select2-selection__arrow {
  background: none;
  display: none !important;
}
.vgt-table td,
.vgt-table th {
  vertical-align: middle !important;
  font-size: 0.85rem;
}
.vgt-table th {
  text-align: center;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>